import React, { useMemo } from 'react';
import { Typography } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { getImagefromBase64 } from '../../../../utils/images';

const resolveCourseImage = (image) => {
  if (!image) {
    return null;
  }
  if (typeof image === 'string') {
    return image;
  }
  if (image?.data) {
    return getImagefromBase64(image);
  }
  return null;
};

const CourseSummarySection = ({
  course,
  institutions,
  pillarName,
  institutionName,
  selectedInstitution,
}) => {
  const institution = useMemo(() => {
    if (selectedInstitution) {
      return selectedInstitution;
    }

    if (course?.institution && typeof course.institution === 'object') {
      return {
        id: course.institution.id,
        value: course.institution.value || course.institution.name || '',
        logo: course.institution.logo,
      };
    }

    const match = institutions?.find(
      (inst) => Number(inst.id) === Number(course?.institution)
    );

    if (match) {
      return match;
    }

    return null;
  }, [course?.institution, institutions, selectedInstitution]);

  const courseImage = resolveCourseImage(course?.image);
  const institutionLabel =
    institutionName || institution?.value || 'Institución no encontrada';

  return (
    <div className="wizard__grid-section">
      <h2>Resumen</h2>
      <div className="container-summary">
        <div className="title-section">
          <h3 color="textSecondary">Título</h3>
          <Typography variant="body1">{course.name}</Typography>
        </div>
        <div className="slug-section">
          <h3 color="textSecondary">Slug</h3>
          <Typography variant="body1">{course.slug}</Typography>
        </div>
        <div className="description-section">
          <h3 color="textSecondary">Descripción</h3>
          <Typography variant="body1">{course.description}</Typography>
        </div>
        <div className="level-section">
          <h3 color="textSecondary">Nivel</h3>
          <Typography variant="body1">{course.nivel || 'Principiante'}</Typography>
        </div>
        <div className="institution-section">
          <h3 color="textSecondary">Institución</h3>
          <Typography variant="body1">{institutionLabel}</Typography>
          {institution && institution.logo && (
            <img
              src={institution.logo}
              alt={`Logo de ${institutionLabel}`}
              style={{
                maxWidth: '150px',
                maxHeight: '50px',
                marginTop: '10px',
              }}
            />
          )}
        </div>
        {courseImage && (
          <div className="image-section">
            <h3 color="textSecondary">Imágen del curso</h3>
            <img
              src={courseImage}
              alt={`Imágen del curso ${course?.name || ''}`}
            />
          </div>
        )}
        <div className="category-section">
          <h3 color="textSecondary">Categoría del curso</h3>
          <div className="category-detail">
            <FiberManualRecordIcon className="FiberManualRecordIcon" />
            {pillarName || 'Pilar no encontrado'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseSummarySection;
